import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

// Loading placeholder for the coach Profile Settings page — the title and a
// large card of labelled form fields (two-column) with a save action.
export default function CoachProfileSkeleton({ isDarkMode }) {
    const baseColor = isDarkMode ? "#334155" : "#e2e8f0";
    const highlightColor = isDarkMode ? "#475569" : "#f1f5f9";

    return (
        <SkeletonTheme baseColor={baseColor} highlightColor={highlightColor}>
            <div className={`max-w-4xl mx-auto space-y-8 p-6 ${isDarkMode ? "bg-surface" : ""}`}>
                <Skeleton width={220} height={32} />
                <div className={`rounded-3xl border shadow-sm p-8 space-y-10 ${isDarkMode ? "bg-slate-800 border-slate-700" : "bg-white border-slate-200"}`}>
                    {Array.from({ length: 2 }).map((_, sec) => (
                        <div key={sec} className="space-y-6">
                            <Skeleton width={180} height={22} />
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                {Array.from({ length: 4 }).map((_, i) => (
                                    <div key={i} className="space-y-2">
                                        <Skeleton width={120} height={11} />
                                        <Skeleton height={44} borderRadius={12} />
                                    </div>
                                ))}
                            </div>
                        </div>
                    ))}
                    <Skeleton width={140} height={44} borderRadius={12} />
                </div>
            </div>
        </SkeletonTheme>
    );
}
